import { render } from "./stats.vue?vue&type=template&id=54ea0006"
import script from "./stats.vue?vue&type=script&lang=js"
export * from "./stats.vue?vue&type=script&lang=js"

import "./stats.vue?vue&type=style&index=0&id=54ea0006&lang=css"
script.render = render

export default script